var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['move-group', 'move-group--'+_vm.status]},[_c('div',{staticClass:"move-group__title"},[_vm._v(_vm._s(_vm.group.label))]),_vm._v(" "),_c('div',{staticClass:"move-group__body"},_vm._l((_vm.group.models),function(model){return _c('move-model',{key:model.id,attrs:{"model":model,"options":_vm.options}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }